// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"dropdown__1bM3c","placeholder":"placeholder__1BLp8","selected":"selected__TOFOz","menu":"menu__3Q7fm"};


//////////////////
// WEBPACK FOOTER
// ./components/search/dropdown/style.scss
// module id = phh3
// module chunks = 27